import { Form, InputNumber, Popconfirm, Table, Typography, Input, Space, Button,notification,Select, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons'
import { useState, useRef,useEffect } from 'react';
import Highlighter from 'react-highlight-words'
import {useAtom} from 'jotai'
import { selectedRecord,accessTokenAtom } from "../atoms";
import moment from 'moment';
import {  useMsal } from '@azure/msal-react';

let tablelabel;

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const [value, setValue] = useState();
    const onHandleChange=(value)=>{
        if(value!="NEW_ITEM")
        setValue(value)
        else{
            setValue("HELLO")
            alert("NO CHANGE HERE")
        }
    }
    const inputNode = inputType === 'number' ? <InputNumber />:<Input />;
    const formNode=(
    <Select style={{ width: '100%' }}>
    {tablelabel=='REC' || tablelabel=='SGREC' ? (
        <>
        <Select.Option value={"I-REC"}>I-REC</Select.Option>
        <Select.Option value={"TIGR"}>TIGR</Select.Option>
        </>
 
    )
    : <Select.Option value={"VCU"}>VCU</Select.Option>}
    </Select>
  )
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
            
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                   {inputNode}
                </Form.Item>
            ):(
                children
                
            )}
        </td>
    );
};

const AnotherTable = ({ defaultColumns,dummyData,label,radio=true,token}) => {

    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([...dummyData]);
    const [searchText, setSearchText] = useState('')
    const [searchedColumn, setSearchedColumn] = useState('')
    const searchInput = useRef(null)
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.serialNumber === editingKey;
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [api, contextHolder] = notification.useNotification();
    const [currentRecord,setCurrentRecord]=useAtom(selectedRecord);
    const [tableSummaryData,setSummaryData]=useState([])
    const [currentRows,setCurrentRows]=useState(5);
    const [accessAtom]=useAtom(accessTokenAtom)
    const [startDate,setStartDate]=useState();
    const [endDate,setEndDate]=useState();
    const { instance, accounts } = useMsal();
    

    useEffect(()=>{
        setDataSource([...dummyData])
    },[dummyData])


      
    tablelabel=label

    const openNotification2 = (message) => {
        api.error({
          message: `Update Error`,
          duration: 3,
          description: message,
          placement:'top',
        });
      };

    const openNotification = () => {
        api.error({
          message: `Delete Error`,
          description:
            'Retirement has been done on this project. Unable to delete.',
          placement:'top',
        });
      };

    const handleEdit = (record) => {
        // use setFieldsValue to be able to validate fields when saving
        // use the href attribute for the certificate field because it
        // is an href object
      
        form.setFieldsValue({
            ...record,
            //projectLink: record['projectLink'].props?.href, // CHANGE THIS TO BACK TO CERTIFICATE FOR RESIDENTIAL
        });
        setEditingKey(record.serialNumber);
    };

    const handleCancel = () => {
        setEditingKey('');
    };

    const paginationChange=(e)=>{
        setCurrentRows(e);
    }


    const onSelectChange = (newSelectedRowKeys, record) => {
        
        
        setSelectedRowKeys(newSelectedRowKeys)
        setCurrentRecord(record[0])
    };
    const rowSelection = {
        selectedRowKeys,
        type: 'radio',
        onSelect: () => console.log('test'),
        onChange: onSelectChange,
    };

    const enumarateDates=(startDate,endDate)=>{
        var dates = [];

        var currDate = moment(startDate).startOf('day');
        var lastDate = moment(endDate).startOf('day');
        dates.push(currDate.clone().format("DD-MM-YYYY"))
    
        while(currDate.add(1, 'days').diff(lastDate) < 0) {
          //  console.log(currDate.format("YYYY-MM-DD"));
            dates.push(currDate.clone().format("DD-MM-YYYY"));
        }
        dates.push(lastDate.clone().format("DD-MM-YYYY"))
     // console.log(dates)
       return dates;
    }

    const toISOLocal = (d) => {
        var z  = n =>  ('0' + n).slice(-2);
        var zz = n => ('00' + n).slice(-3);
        var off = d.getTimezoneOffset();
        var sign = off > 0? '-' : '+';
        off = Math.abs(off);
      
        return d.getFullYear() + '-' + z(d.getMonth() + 1) + '-' + 
        z(d.getDate()) + 'T' + z(d.getHours()) + ':' + z(d.getMinutes()) + ':' + z(d.getSeconds()) + '.' + zz(d.getMilliseconds()) + 'Z'; 
      }

    const handleSave = async (record) => {
        try {
            const row = await form.validateFields();
            
            // If the edited cell in the row is a link, then transform
            // the data to be saved
            // CHANGE THIS LINK TO BACK TO CERTIFICATE FOR RESIDENTIAL
            // if (row['projectLink']) {
            //     row['projectLink'] =  <a href={row['projectLink']} target="_blank" rel="noreferrer">Link</a>
            // }
            const newData = [...dataSource];
            const index = newData.findIndex((item) => record.serialNumber === item.serialNumber);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
                try {
                    item.modifiedBy = accounts[0].name;
                    item.modifiedDate = toISOLocal(new Date());
                    const response = await fetch(`${process.env.REACT_APP_API_URL}ActiveProject/UpdateActiveProject`, {
                        method: 'PUT',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            "Authorization":`Bearer ${token}`
                        },
                        body: JSON.stringify(item)
                        });
                    const responseJson = await response.json();
                    if (responseJson.messageCode == "201") {
                        setDataSource(newData);
                    }
                    else {
                        openNotification2(responseJson.message);
                    }
                } catch (error) {                    
                    console.log("UpdateActiveProject error", error);
                }
                setEditingKey('');
            } else {
                newData.push(row);
                setDataSource(newData);
                setEditingKey('');
            }
        } catch (errInfo) {
            
        }
    };

    const handleDelete = (record) => {
        const newData = dataSource.filter((item) => item.id !== record.id);
        fetch(`${process.env.REACT_APP_API_URL}ActiveProject/DeleteProjectV2?projectId=${record.id}&modifiedBy=${accounts[0].name}`, {
            method: 'DELETE', 
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "Authorization":`Bearer ${token}`
        }})
        setDataSource(newData);
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
     confirm()
        if(dataIndex.toLowerCase().includes("date") || dataIndex.toLowerCase().includes("period")){
            let curr=moment(selectedKeys[dataIndex]).format("YYYY-MM-DD")
            let x=""
            let y=""
            console.log("RECH",selectedKeys.length)
            if (selectedKeys.every(entry => !Array.isArray(entry))) {
                // One dimensional
            } else {
                x=selectedKeys[0][0].format('YYYY-MM-DD')//start
                y=selectedKeys[0][1].format('YYYY-MM-DD')//end
            }
          
            const dateArr=enumarateDates(x,y)
            setSearchText((selectedKeys.length === 0 ? selectedKeys[0]:dateArr))
            console.log(dateArr)
        }else{
            setSearchText((selectedKeys.length === 0 && '') || selectedKeys[0])
        }
      console.log("SELECTED KEYS?",selectedKeys)

     setSearchedColumn(dataIndex)

     console.log(searchText);
    }

    const handleReset = (clearFilters, confirm, dataIndex) => {
        clearFilters()
        setSearchedColumn('')
        if(dataIndex.toLowerCase().includes("date")){
            setStartDate(null)
            setEndDate(null)
            handleSearch([], confirm, dataIndex)
        }else{
            handleSearch([], confirm, dataIndex)
        }

    }

    function isIsoDate(str) {
        // if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{2}$/.test(str)) return false;
        // const d = new Date(str); 
        // return d instanceof Date && !isNaN(d) && d.toISOString()===str; // valid date 
        return ((/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{0,3}$/.test(str)) || (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(str)))
      }

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                {(dataIndex.toLowerCase().includes("date") || dataIndex.toLowerCase().includes("period"))?<DatePicker.RangePicker
                onChange={(date,dateString)=>{
                    setStartDate(date[0])
                    setEndDate(date[1])
                    setSelectedKeys([date])
                }}
                value={[startDate,endDate]}
                />:
                <Input
                ref={searchInput}
                placeholder={`Search ${dataIndex}`}
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                style={{
                    marginBottom: 8,
                    display: 'block',
                }}
            />
            }
       
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters, confirm, dataIndex)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>{
        if(dataIndex.toLowerCase().includes("date") || dataIndex.toLowerCase().includes("period")){
  
        const curr=moment(record[dataIndex]).format("YYYY-MM-DD")
        const x=value[0].format('YYYY-MM-DD')
        const y=value[1].format('YYYY-MM-DD')

        const ch=moment(curr).isBetween(x, y)


        return moment(curr).isBetween(x,y,null, '[]')
        }
        else{
            return record[dataIndex]!=null?record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()):null
        }
          
        },
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100)
            }
        },
        render: (text,record) =>{
            let dateDisplay;
            //console.log("WTS",text)
            if(isIsoDate(text)){
            const date = new Date(text);
            // Get the day, month, and year from the date object
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // month is 0-indexed
            const year = date.getFullYear().toString();
            // Combine the day, month, and year into a single string with the desired format
            dateDisplay = `${day}-${month}-${year}`;
            }
           // console.log("inside render",text,record)
            return(
                
            (searchedColumn === dataIndex && (searchText!=undefined && searchText.length>0)) ? (
                
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={(isIsoDate(text) && text!=null && text!='')?searchText:[searchText]}
                    autoEscape
                    textToHighlight={(isIsoDate(text))?dateDisplay : text?text.toString():''}
                />
                
            ) : (
                isIsoDate(text)?dateDisplay:text
            )
            
        //    isIsoDate(text)?dateDisplay:text
            )}
    })

    
    const columns = defaultColumns.map((col) => {
        // Column certificate doesnt need to have search filter
        // CHANGE THIS LINK TO BACK TO CERTIFICATE FOR RESIDENTIAL
        if (col.dataIndex === 'projectLink' || col.dataIndex==='certificateUrl') {
            return col
        }
        
        // Add a search filter functionality
        const newCol = {
            ...col,
            ...getColumnSearchProps(col.dataIndex),
        }

        if (col.dataIndex !== 'operation') {
            return newCol
        }
        
        // Add edit and delete functionality under the column "operation"
        return {
            ...col,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            onClick={() => handleSave(record)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            Save
                        </Typography.Link>
                        <Typography.Link
                            onClick={handleCancel}
                            style={{
                                marginRight: 0,
                            }}
                        >
                            Cancel
                        </Typography.Link>
                    </span>
                ) : (
                    <span>
                        <Typography.Link disabled={record.availableQuantity==record.totalQuantity?false:true} onClick={() => handleEdit(record)} style={{'marginRight': '8px'}}>
                            Edit
                        </Typography.Link>
                        {/* <Popconfirm title="Do you want to remove this record?" onConfirm={() => handleDelete(record)} disabled={record.availableQuantity==record.totalQuantity?false:true}>
                            <Typography.Link>
                                Delete
                            </Typography.Link>
                        </Popconfirm> */}
                        {record.availableQuantity==record.totalQuantity?   <Popconfirm title="Do you want to remove this record?" onConfirm={() => handleDelete(record)} disabled={record.availableQuantity==record.totalQuantity?false:true}>
                            <Typography.Link>
                                Delete
                            </Typography.Link>
                        </Popconfirm>: <Typography.Link onClick={()=>openNotification()}>
                                Delete
                            </Typography.Link>}

                    </span>
                );
            },
        }
    })
    
    // Make the cell of each row editable
    const mergedColumns = columns.map((col) => {
       
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ? 'number':col.dataIndex==='category'?'input' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    const components = {
        body: {
            cell: EditableCell,
        },
    }

    return (
        <div style={{}}>
            {contextHolder}
        <Form form={form} component={false}>
            <Table
                summary={(data) => {
                    // parse the certificate object
                    // get only the href string
                    const x = data.map(d => ({
                        ...d,
                        // ...("certificate" in d && {certificate: d.certificate?.props?.href}),
                        ...("projectLink" in d && {link: d.link?.props?.href})
                    }))

                    //console.log("data",data)
          
                   
                    // Summary needs to return a React.ReactNode
                    // We need this so that we can get a reference
                    // to the current data of the table when we
                    // export to excel or pdf 
                    return (
                        <>
                            <Table.Summary.Row>
                                <Table.Summary.Cell className='test-data d-none'>
                                    {JSON.stringify(x)}
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    )
                }}
                components={components}
                bordered
                dataSource={[...dataSource]}
                columns={mergedColumns}
                rowKey={"id"}
                rowSelection={radio==true?rowSelection:null}
                rowClassName="editable-row"
                pagination={{
                    pageSize: currentRows,
                    onChange: (page,pageSize)=>setCurrentRows(pageSize),
                    showSizeChanger:true
                }}
            />
        </Form>
            
        </div>
    );
};

export default AnotherTable;